"use client";

import Script from "next/script";

const FeedbackWidget = () => {
  return (
    <Script
      src="https://www.boosttoad.com/api/widget/bundle?projectId=3df91e99-ee01-4aa0-8a34-73acb02eff9e"
      strategy="afterInteractive"
    />
  );
};

export default FeedbackWidget;
